import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Paper } from '@mui/material'
import { colors } from '@global/constants'

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 60px;
`

export const FlexPaper = styled(Paper)`
  width: 100%;
  height: 100%;
  flex: 1;
  overflow: hidden;
`

export const TitleContainer = styled.div`
  padding: 15px;
  flex-shrink: 1;
`

export const TableFiltersContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
  padding: 15px 50px;
`

export const SearchBar = styled.div`
  flex: 1;
`

export const TableContainer = styled.div`
  flex: 1;
  height: calc(100% - 82px);
  overflowy: scroll;
`

export const table = css`
  width: 100%;
  max-width: 100%;
  flex: 1;
  overflow: hidden;
  table-layout: fixed;
`

export const emptyStateFab = css`
  width: 65px;
  height: 65px;
  color: ${colors.gray.main};
  cursor: auto;
`

export const emptyStateIcon = css`
  font-size: 34px;
  color: ${colors.blue.smokey};
`

export const textField = css`
  width: 100%;
`

export const hoverable = css`
  cursor: pointer;
`

export const flexColumn = css`
  height: 100%;
  display: flex;
  flex-direction: column;
`
